 <!-- Commented on 20th April 2026 for the breadcrumb changes -->
<!-- <div class="card-header bg-white" [hidden]="showselector">
    <div>
        <div class="col-6 mb-2">
            <label for="name" class="form-label">Plant:</label>
            <select class="form-select border border-dark" name="plantid" (change)="getSelectedId($event)">
                <option [selected]>Select Plant</option>
                <option *ngFor="let plant of plants" [value]="plant.Id">
                    {{ plant.Name }}
                </option>
            </select>
        </div>

        <div class="col-6">
            <label for="train" class="form-label">Train:</label>
            <select class="form-select border border-dark" name="trainid" (change)="getSelectedTrainId($event)">
                <option [selected]>Select Train</option>
                <option *ngFor="let train of trains" [value]="train.Id">
                    {{ train.Name }}
                </option>
            </select>
        </div>
    </div>
</div> -->
<div class="row mb-3 mt-2">
    <div class="col-1" style="margin-left: 10px;">Field 1:</div>
    <div class="col-3" style="text-align: left">
        <select class="form-select border border-dark" [(ngModel)]="field1" name="field1" id="field1"
            (change)="onOptionSelectedfield_1($event)" disabled="{{selections}}">
            <option *ngFor="let stages of fieldDDl" [value]="stages.value"
                [selected]="stages.value === field1">
                {{ stages.label }}
            </option>
        </select>
    </div>
    <div class="col-2">

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="!UDSelectedF1" disabled="{{selections}}">
            <option *ngFor="let stages of stageTotal" [value]="stages.Id"
                [selected]="stages.Id === trainDetails.Stages">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="+trainDetails.Stages == 1 && UDSelectedF1" disabled="{{selections}}">
            <option *ngFor="let stages of stageTotal" [value]="stages.Id"
                [selected]="stages.Id === trainDetails.Stages">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="+trainDetails.Stages == 2 && UDSelectedF1" disabled="{{selections}}">
            <option *ngFor="let stages of stage2" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="+trainDetails.Stages == 3 && UDSelectedF1" disabled="{{selections}}">
            <option *ngFor="let stages of stage3" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>
    </div>
</div>
<div class="row mb-3 mt-2">
    <div class="col-1" style="margin-left: 10px;">Field 2:</div>
    <div class="col-3" style="text-align: left">
        <select class="form-select border border-dark" [(ngModel)]="field2" name="field2" id="field2"
            (change)="onOptionSelectedfield_2($event)" disabled="{{selections}}">
            <option *ngFor="let stages of fieldDDl" [value]="stages.value"
            [selected]="stages.value === field2">
                {{ stages.label }}
            </option>
        </select>
    </div>

    <div class="col-2">

        <select class="form-select border border-dark" [(ngModel)]="Stage2" name="Stage2" id="Stage2"
            *ngIf="!UDSelectedF2" disabled="{{selections}}">
            <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage2" name="Stage2" id="Stage2"
            *ngIf="+trainDetails.Stages == 1 && UDSelectedF2" disabled="{{selections}}">
            <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage2" name="Stage2" id="Stage2"
            *ngIf="+trainDetails.Stages == 2 && UDSelectedF2" disabled="{{selections}}">
            <option *ngFor="let stages of stage2" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage2" name="Stage2" id="Stage2"
            *ngIf="+trainDetails.Stages == 3 && UDSelectedF2" disabled="{{selections}}">
            <option *ngFor="let stages of stage3" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>
    </div>


</div>
<div class="row mb-3 mt-2">
    <div class="col-1" style="margin-left: 10px;">Field 3:</div>
    <div class="col-3" style="text-align: left">
        <select class="form-select border border-dark" [(ngModel)]="field3" name="field3" id="field3"
            (change)="onOptionSelectedfield_3($event)" disabled="{{selections}}">
            <option *ngFor="let stages of fieldDDl" [value]="stages.value"
            [selected]="stages.value === field3">
                {{ stages.label }}
            </option>
        </select>
    </div>
    <div class="col-2">
       

        <select class="form-select border border-dark" [(ngModel)]="Stage3" name="Stage3" id="Stage3"
            *ngIf="!UDSelectedF3" disabled="{{selections}}">
            <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage3" name="Stage3" id="Stage3"
            *ngIf="+trainDetails.Stages == 1 && UDSelectedF3" disabled="{{selections}}">
            <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage3" name="Stage3" id="Stage3"
            *ngIf="+trainDetails.Stages == 2 && UDSelectedF3" disabled="{{selections}}">
            <option *ngFor="let stages of stage2" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage3" name="Stage3" id="Stage3"
            *ngIf="+trainDetails.Stages == 3 && UDSelectedF3" disabled="{{selections}}">
            <option *ngFor="let stages of stage3" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>
    </div>
</div>
<div class="row  mb-3 mt-2">
    <div class="col-1"></div>
    <div class="col-5">
        <button type="button" class="btn" (click)="showGraph()">
            Generate Custom Graph
        </button>
        <button [hidden]="!downloadbtn" style="margin-left: 20px;" type="button" class="btn" 
        (click)="captureScreen()">Download</button>
    </div>
        
</div>
<div #captureArea>
    <div style="padding: 10px;">
        <div class="row mb-3 mt-2">
            <div class="col-6">
                <label>Title</label>
                <div style="padding: 7px;border: 1px solid black;height: 80px;">
                    <h4 [innerHtml]="graphName"></h4>
                </div>
            </div>
            <div class="col-6">
                <label>Legends</label>
                <div style="padding: 7px;border: 1px solid black;height: 80px;">
    
                    <p *ngIf="field1Name" style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill" style="font-size: 10px; color: blue;"></i>
                        F1 {{field1Name}}/{{getStageLabel(Stage1)}}</p>
                    <p *ngIf="field2Name" style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill" style="font-size: 10px; color: red;"></i>
                        F2 {{field2Name}}/{{getStageLabel(Stage2)}}</p>
                    <p *ngIf="field3Name" style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                            style="font-size: 10px; color: green;"></i>
                        F3 {{field3Name}}/{{getStageLabel(Stage3)}}</p>
                </div>
            </div>
        </div>
    
        <div class="row" style="text-align: center;">
    
        <div id="plot" style="border:deepskyblue;" style="height: 700px;width: NewWidth;"> 
       
            </div>
        </div>   
    </div>
</div>
